var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.333 1.32153V10.8332H31.8447L22.333 1.32153Z",
    fill: "url(#paint0_linear_1622_22698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 12.4999C21.0398 12.4999 20.6665 12.1266 20.6665 11.6666V2.83325C20.6665 1.72868 19.7711 0.833252 18.6665 0.833252H1.49984C1.03984 0.833252 0.666504 1.20659 0.666504 1.66659V38.3333C0.666504 38.7933 1.03984 39.1666 1.49984 39.1666H31.4998C31.9598 39.1666 32.3332 38.7933 32.3332 38.3333V14.4999C32.3332 13.3954 31.4377 12.4999 30.3332 12.4999H21.4998ZM8.1665 12.4999H14.8332C15.2932 12.4999 15.6665 12.8733 15.6665 13.3333C15.6665 13.7933 15.2932 14.1666 14.8332 14.1666H8.1665C7.7065 14.1666 7.33317 13.7933 7.33317 13.3333C7.33317 12.8733 7.7065 12.4999 8.1665 12.4999ZM24.8332 30.8333H8.1665C7.7065 30.8333 7.33317 30.4599 7.33317 29.9999C7.33317 29.5399 7.7065 29.1666 8.1665 29.1666H24.8332C25.2932 29.1666 25.6665 29.5399 25.6665 29.9999C25.6665 30.4599 25.2932 30.8333 24.8332 30.8333ZM24.8332 22.4999H8.1665C7.7065 22.4999 7.33317 22.1266 7.33317 21.6666C7.33317 21.2066 7.7065 20.8333 8.1665 20.8333H24.8332C25.2932 20.8333 25.6665 21.2066 25.6665 21.6666C25.6665 22.1266 25.2932 22.4999 24.8332 22.4999Z",
    fill: "url(#paint1_linear_1622_22698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1622_22698",
    x1: 27.0888,
    y1: 1.32153,
    x2: 22.333,
    y2: 14.6532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65A30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECFAD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1622_22698",
    x1: 16.4998,
    y1: 0.833252,
    x2: 7.72628,
    y2: 36.1206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65A30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECFAD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimFile);
export default __webpack_public_path__ + "static/media/claim-file.e267d269d678b71a3c587effa62f7225.svg";
export { ForwardRef as ReactComponent };